export const ROUTES = {
  HOME: "/",
  MAILS: "/mails",
  SENT_MAILS: "/sent-mails",
  EMAIL_COMPOSE: "/mails/compose",
  BOOKMARKS: "/bookmarks",
  WORLD_OF_STAMPS: "/world-of-stamps",
  WORLD_OF_STAMPS_DISCOVER: "/world-of-stamps/discover",
  WORLD_OF_STAMPS_ME: "/world-of-stamps/me",
  SETTINGS: "/settings",
};

export const BREAKPOINTS = {
  XS: "320px",
  SM: "480px",
  MD: "768px",
  LG: "1024px",
  XL: "1200px",
};

export const LISBON = {
  RPC: "https://lisbon.net.solidwallet.io/api/v3",
  NID: 2,
  VER: 3,
};
export const STEP = {
  MIN: 3178800, // about 3.2 million
  MEDIUM: "1100000000", // about 1.1 billion, for deployment
  MAX: 2500000000, //2.5 billion
};

export const SCORE = {
  SBT_USER: "cx57c71d9ff3c1dcacbf10758f021ee2c61190ef9b",
  // STAMP: "cx899530f7541189e2b739f1393d34590556d4078e",
  // STAMP: "cxe2694d7d71d0cc476fac78430eb47e210ff4d1e6",
  // STAMP: "cxbe72b2bd04d77ae184a81de307ba26c29a8ac163",
  STAMP: "cxf7b16e5cf917cfe8cc27951be2d4c88d467542d8",
};
